<template>
  <div class="hello">

    <b-container>

        <!-- Modal to confirm close contacts without saving -->
        <b-modal id="modal-confirmclose" title="Close without saving" ok-title="Yes, Close" cancel-title="No, Wait" @ok="closeContacts"> 
            Close without saving?
        </b-modal>

        <!-- Show all contacts -->
        <b-button v-b-modal.modal-showcontacts variant='info'>Show And Edit All Contacts</b-button>

        <!-- Manually entered emails -->
        <h4 style="margin-top:20px">Manually Add Contact Emails</h4>
        <b-form-group 
            class="mb-0"
            label-for="textarea-formatter-delivery"
            description="Emails, separated by commas"
            >
            <b-form-textarea
                id="textarea-formatter-delivery"
                v-model="manualEmails"
                placeholder="Emails, separated by commas"
            ></b-form-textarea>
        </b-form-group>
        <b-button @click="addEmails()">Add These Emails</b-button>

        <!-- Show all contacts -->
        
        <b-modal scrollable id="modal-showcontacts" title="Contacts" size='xl' @ok="updateContacts()" ok-title="Update" 
            header-bg-variant="dark" header-text-variant="light" footer-bg-variant='dark'
            no-close-on-backdrop @cancel="confirmCloseContacts">
            
            <b-button @click="addNewContact()" style="margin-bottom:10px" variant='info'>Add New</b-button>
            <table class="table bordered">
                <thead thead class="thead-dark" style="font-size:10px">
                    <tr>
                        <th>Company</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Address</th>
                        <th>Phone</th>
                        <th>Comments</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for='contact in userContacts' :key="contact.id" style="font-size:10px">
                        <td><b-form-input @change="contactsEdited=true" size="sm" v-model.trim="contact.company"></b-form-input></td>
                        <td><b-form-input @change="contactsEdited=true" size="sm" v-model.trim="contact.contactname"></b-form-input></td>
                        <td><b-form-input @change="contactsEdited=true" size="sm" v-model.trim="contact.email"></b-form-input></td>
                        <td><b-form-input @change="contactsEdited=true" size="sm" v-model.trim="contact.address"></b-form-input></td>
                        <td><b-form-input @change="contactsEdited=true" size="sm" v-model.trim="contact.phone"></b-form-input></td>
                        <td><b-form-input @change="contactsEdited=true" size="sm" v-model.trim="contact.comments"></b-form-input></td>
                        <td> <b-button size="sm" @click="deleteContact(contact)"  variant='danger'><font-awesome-icon icon="trash-alt" /></b-button></td>
                    </tr>
                </tbody>
            </table>
        </b-modal>
        <!---------------->
        <!-- Import CSV -->
        <!---------------->
        <hr>
        <h4>Upload Contacts from CSV File</h4>
        <!-- Select fields in CSV files -->
        <h6 style='color:red'>CSV file must have a header as the first row, matching the fields selected below, sequence of columns doesn't matter</h6>
        <h5>Select fields in the CSV file</h5>
        
        <b-form-checkbox style="margin-left:5px" id="checkbox-barrels1" v-model="includeCompany" name="checkbox-barrels1" 
            @change="checkboxChanged()" value="yes" unchecked-value="no">
            <span style="margin-left:5px">Company</span>
        </b-form-checkbox>
        <b-form-checkbox style="margin-left:5px" id="checkbox-barrels2" v-model="includeName" name="checkbox-barrels1" value="yes" @change="checkboxChanged()" unchecked-value="no">
            <span style="margin-left:5px">Contact</span>
        </b-form-checkbox>
        <b-form-checkbox style="margin-left:5px" id="checkbox-barrels3" v-model="includeEmail" name="checkbox-barrels1" value="yes" @change="checkboxChanged()" unchecked-value="no">
            <span style="margin-left:5px">Email</span>
        </b-form-checkbox>
        <b-form-checkbox style="margin-left:5px" id="checkbox-barrels4" v-model="includePhone" name="checkbox-barrels1" value="yes" @change="checkboxChanged()" unchecked-value="no">
            <span style="margin-left:5px">Phone</span>
        </b-form-checkbox>
        <b-form-checkbox style="margin-left:5px" id="checkbox-barrels5" v-model="includeAddress" name="checkbox-barrels1" value="yes" @change="checkboxChanged()" unchecked-value="no">
            <span style="margin-left:5px">Address</span>
        </b-form-checkbox>
        
        <!-- CSV import component -->
        <small>First Choose File, then click Load</small>
        <vue-csv-import v-if="renderComponent" :id='fakeCsvId' v-model="contactCSV" :map-fields="getCSVFields"
        :autoMatchFields='true' :autoMatchIgnoreCase='true' :headers='false'>
            <template slot="next" slot-scope="{load}">
                <b-button @click.prevent="load">Load File</b-button>
            </template>
            <template slot="error">
                <h6 style="color:red">File type is invalid, only CSV files can be uploaded</h6>
            </template>
        </vue-csv-import>
        <!-- Upload CSV -->
        <b-row v-if="contactCSV.length>0" style="margin-bottom:10px">
            <b-col>
                <b-button variant="info" @click="uploadContactsFromCsv()">UPLOAD</b-button>
            </b-col>
        </b-row>

        <!-- Table for contacts from CSV file -->
        <table class="table bordered" v-if="getContactsFromCsv.length>0">
            <thead thead class="thead-dark" style="font-size:10px">
                <tr>
                    <th>Select</th>
                    <th v-if="csvFieldsArray.includes('Company')">Company</th>
                    <th v-if="csvFieldsArray.includes('Contact')">Contact</th>
                    <th v-if="csvFieldsArray.includes('Email')">Email</th>
                    <th v-if="csvFieldsArray.includes('Phone')">Phone</th>
                    <th v-if="csvFieldsArray.includes('Address')">Phone</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for='contact in getContactsFromCsv' :key="contact.Email" style="font-size:10px">
                    <td>
                        <b-form-checkbox style="margin-left:5px" :id="'checkbox-barrels5'+contact.id" v-model="contact.selected" value="yes" unchecked-value="no">
                        </b-form-checkbox>
                    </td>
                    <td v-if="csvFieldsArray.includes('Company')">{{contact.Company}}</td>
                    <td v-if="csvFieldsArray.includes('Contact')">{{contact.Contact}}</td>
                    <td v-if="csvFieldsArray.includes('Email')">{{contact.Email}}</td>
                    <td v-if="csvFieldsArray.includes('Phone')">{{contact.Phone}}</td>
                    <td v-if="csvFieldsArray.includes('Address')">{{contact.Address}}</td>

                </tr>
            </tbody>
        </table>

    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')
import { VueCsvImport } from 'vue-csv-import';

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser']),
        //Check if CSV import complete
        getCSVFields(){
            return this.csvFieldsArray
        },

        //Get the new contacts
        getContactsFromCsv(){
            var theContactsList = []
            const min=11111111111111111; 
            const max=99999999999999999; 

            for (var i=0; i<this.contactCSV.length; i++){
                //Skip first one, as it's the fields array
                if(i==0){
                    continue
                }
                var newContact = this.contactCSV[i]
                newContact.selected='yes'
                
                const randomId = Math.floor(Math.random() * (+max - +min)) + +min; 
                const randomIdString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
                newContact.id=randomIdString
                theContactsList.push(newContact)
            }
            return theContactsList
        },
    },

    components: {
        VueCsvImport,
    },

    data() {
        return {
            manualEmails:'',
            userContacts:[],
            contactsEdited:false,
            contactCSV:[],

            //CSV fields selected by brewer
            csvFieldsArray:['Company', 'Contact', 'Email', 'Address', 'Phone'],
            includeName:'yes',
            includeCompany:'yes',
            includeEmail:'yes',
            includePhone:'yes',
            includeAddress:'yes',
            fakeCsvId:1,
            renderComponent:true,


        }
    },

    methods:{
        addEmails(){
            const emailsArray = this.extractEmails(this.manualEmails)
            console.log("emailsArray=")
            console.log(emailsArray)

            //Check emails that already exist
            const existingEmails = this.userProfile.manualEmails
            var emailsToAdd = []
            if(this.userProfile.manualEmails) emailsToAdd = this.userProfile.manualEmails
            //Iterate over new emails
            for (var i=0; i<emailsArray.length; i++){
                //Check if already exists in manual emails
                const existingEmailIndex = emailsToAdd.findIndex(item => item === emailsArray[i])
                if(existingEmailIndex<0){
                    //Add to manaul emails
                    emailsToAdd.push(emailsArray[i])
                } 
                //Check if already exists in user contacts
                const existingContactIndex = this.userContacts.findIndex(item => item.email.toLowerCase() === emailsArray[i].toLowerCase())
                if(existingContactIndex<0){
                    //Add to contacts
                    const min=11111111111111111; 
                    const max=99999999999999999; 
                    const randomId = Math.floor(Math.random() * (+max - +min)) + +min; 
                    const randomIdString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
                    const thisContact = {company:'', email:emailsArray[i].toLowerCase(), address:'', phone:'', contactname:'',comments:'', id:randomIdString}
                    this.userContacts.push(thisContact)
                }
            }

            //Add to userProfile
            fb.usersCollection.doc(this.currentUser.uid).update({
                    manualEmails:emailsToAdd,
                    contacts:this.userContacts,
                })


            
        },
        //Extract emails from manual entry field
        extractEmails (text)
        {
            return text.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
        },

        //Show table of all contacts
        showContacts(){

        },

        //Update contacts
        updateContacts(){
            console.log("Contacts = ")
            console.log(this.userContacts)
            var finalConcatsList = []
            //Iterate over all items and discard empties
            for (var i=0; i<this.userContacts.length; i++){
                const thisContact = this.userContacts[i]
                //Check if something has been entered
                if(thisContact.company.length>0||thisContact.email.length>0||thisContact.address.length>0||thisContact.phone.length>0||thisContact.contactname.length>0||thisContact.comments.length>0){
                    finalConcatsList.push(thisContact)
                }
                else console.log("Blank contact")
            }
            fb.usersCollection.doc(this.currentUser.uid).update({
                contacts:finalConcatsList,
            })
            //Update contacts list with new list
            this.userContacts = finalConcatsList
            this.contactsEdited=false
        },
        

        //Placeholder for new contact
        addNewContact(){
            const min=11111111111111111; 
            const max=99999999999999999; 
            const randomId = Math.floor(Math.random() * (+max - +min)) + +min; 
            const randomIdString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
            var newContact = {company:'', email:'', address:'', phone:'', contactname:'',comments:'', id:randomIdString}
            this.userContacts.splice(0, 0, newContact);
        },

        //Confirmation to close contacts window without saving
        confirmCloseContacts(bvModalEvt){
            //Check if contacts were edited
            if(this.contactsEdited){
                bvModalEvt.preventDefault()
                this.$bvModal.show("modal-confirmclose")
            }
            //Noting edited, close
            else this.closeContacts()

        },
        closeContacts(){
            this.$bvModal.hide("modal-showcontacts")
        },
        //Delete contact
        deleteContact(contact){
            //Find contact
            const existingContactIndex = this.userContacts.findIndex(item => item.id === contact.id)
            this.userContacts.splice(existingContactIndex, 1)
            //Update
            this.updateContacts()
        },
        //User changed CSV fields
        checkboxChanged(){
            var newFieldsArray=[]
            this.renderComponent=false
            if(this.includeCompany=='yes') newFieldsArray.push('Company')
            if(this.includeName=='yes') newFieldsArray.push('Contact')
            if(this.includeEmail=='yes') newFieldsArray.push('Email')
            if(this.includePhone=='yes') newFieldsArray.push('Phone')
            if(this.includeAddress=='yes') newFieldsArray.push('Address')
            this.csvFieldsArray=newFieldsArray
            this.fakeCsvId++
            this.$nextTick(() => {
                // Add the component back in
                this.renderComponent = true;
            });
        },

        //Upload contacts from CSV
        uploadContactsFromCsv(){
            for (var i=0; i<this.getContactsFromCsv.length; i++){
                var thisContact = this.getContactsFromCsv[i]
                if(thisContact.selected=='no'){
                    console.log(thisContact.Company + ' was skipped')
                }
                else{
                    //Check all fields
                    if(!thisContact.Company) thisContact.Company=''
                    if(!thisContact.Email) thisContact.Email=''
                    if(!thisContact.Address) thisContact.Address=''
                    if(!thisContact.Phone) thisContact.Phone=''
                    if(!thisContact.Contact) thisContact.Contact=''

                    //Create the new contact
                    var newContact = {company:thisContact.Company, email:thisContact.Email.toLowerCase(), address:thisContact.Address, phone:thisContact.Phone, contactname:thisContact.Contact, comments:'', id:thisContact.id}
                    //Check if email already in contacts list, if yes, replace with CSV
                    const existingEmailIndex = this.userContacts.findIndex(item => item.email.toLowerCase() === thisContact.Email.toLowerCase())
                    //If exists, replace
                    if(existingEmailIndex>=0){
                        this.userContacts.splice(existingEmailIndex, 1, newContact)
                    }
                    //Doesn't exist, add
                    else this.userContacts.push(newContact)

                }
            }
            //Update contacts
            this.updateContacts()
            //Empty the CSV
            this.contactCSV=[]

             //Show toast
            this.$bvToast.toast('All contacts have been uploaded', {
                title: 'Contacts Uploaded!',
                solid:true,
                variant: 'success',
                autoHideDelay: 5000,
                appendToast: false
            })

            //Reinit CSV load
            this.renderComponent=false
            this.$nextTick(() => {
                // Add the component back in
                this.renderComponent = true;
            });
            
           

        },
    },

    mounted(){

        //Check if already has contacts
        if(this.userProfile.contacts){
            this.userContacts=JSON.parse(JSON.stringify(this.userProfile.contacts))
        } 
    },
}
</script>

